import React from 'react'

import { FormattedMessage } from 'react-intl'

import logo from '@images/brand-logo-full.png'
import Theme from '@theme'
import { Container, Header } from '@tribegroup'
import { Title } from './Header.styled'

const CampaignCreatorsHeader: React.FC = () => (
  <React.Fragment>
    <Container
      topOuterSpacing={3.875}
      width={9.5}
      height={2.25}
      data-testid="campaign-creators-logo"
      flexCenter
    >
      <img width="auto%" height="100%" src={logo} alt="brand-logo" />
    </Container>
    <Container topOuterSpacing={1.5}>
      <Title>
        <FormattedMessage id="campaignCreators.header.title" />
      </Title>
    </Container>
    <Container topOuterSpacing={0.75} bottomOuterSpacing={1.5}>
      <Header small color={Theme.grey700Color} uppercase>
        <FormattedMessage id="campaignCreators.header.subtitle" />
      </Header>
    </Container>
  </React.Fragment>
)

export { CampaignCreatorsHeader }
export default CampaignCreatorsHeader
